(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["beanie-photo-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-beanie-scroll]');
 if(!button)return;
 button.closest('.beanie-photo-picker').querySelector('.beanie-photo-picker__track').scrollBy({left:Number(button.dataset.beanieScroll)*194,behavior:'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["boxer-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-guide-unit]');
 if(!button)return;
 const guide=button.closest('[data-boxer-guide]');
 if(!guide)return;
 const unit=button.dataset.guideUnit;
 guide.dataset.unit=unit;
 guide.querySelectorAll('[data-guide-unit]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 guide.querySelectorAll('[data-unit-value]').forEach(item=>item.hidden=item.dataset.unitValue!==unit);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["compact-review-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('compact-review-bar')) {
    customElements.define('compact-review-bar', class extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('[data-review-item]')];
        this.mobile = window.matchMedia('(max-width: 699px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 1;
        this.abort = new AbortController();
        this.mobile.addEventListener('change', () => {
          this.items.forEach(item => item.getAnimations().forEach(animation => animation.cancel()));
          this.update();
        }, {signal: this.abort.signal});
        this.setAttribute('data-ready', '');
        this.update();
        this.timer = window.setInterval(() => {
          if (this.mobile.matches && !document.hidden && !this.contains(document.activeElement)) this.next();
        }, 5000);
      }
      next() {
        const outgoing = this.items[this.index];
        this.index = (this.index + 1) % this.items.length;
        const incoming = this.items[this.index];
        this.update();
        if (!this.motion.matches) {
          const options = {duration: 450, easing: 'cubic-bezier(.25,.1,.25,1)'};
          outgoing.animate([{transform: 'translateX(0)'}, {transform: 'translateX(-100%)'}], options);
          incoming.animate([{transform: 'translateX(100%)'}, {transform: 'translateX(0)'}], options);
        }
      }
      update() {
        this.items.forEach((item, index) => {
          const hidden = this.mobile.matches && index !== this.index;
          item.setAttribute('aria-hidden', String(hidden));
          item.inert = hidden;
        });
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["discount-activated-bar"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.getElementById('giovici-discount-notice');
  if (!bar) return;
  const storageKey = 'giovici-dismissed-discount-notice';
  let currentCode = '';
  let dismissedCode = '';
  try { dismissedCode = sessionStorage.getItem(storageKey) || ''; } catch (_) {}
  const update = () => {
    const cookie = document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith('discount_code='));
    currentCode = cookie ? cookie.slice('discount_code='.length) : '';
    bar.hidden = !currentCode || currentCode === dismissedCode;
  };
  bar.querySelector('button').addEventListener('click', () => {
    dismissedCode = currentCode;
    bar.hidden = true;
    try { sessionStorage.setItem(storageKey, dismissedCode); } catch (_) {}
  });
  update();
  window.addEventListener('pageshow', update);
  window.addEventListener('focus', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["giovici-kaching-style"] && !Shopify.designMode) return;
  try {
    (() => {
 let pending = false;
 const update = () => {
  pending = false;
  document.querySelectorAll('.kaching-bundles__bar').forEach(bar => {
   const source = bar.querySelector('.kaching-bundles__bar-most-popular__content');
   const label = bar.querySelector('.kaching-bundles__bar-label');
   if (!source || !label) return;
   const text = source.textContent.trim();
   if (text && label.textContent.trim() !== text) label.textContent = text;
  });
 };
 new MutationObserver(() => {
  if (!pending) { pending = true; requestAnimationFrame(update); }
 }).observe(document.body, {childList:true,subtree:true,characterData:true});
 update();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-resources"] && !Shopify.designMode) return;
  try {
    (() => {
    let scheduled = false;
    const formatRatings = () => {
      scheduled = false;
      document.querySelectorAll('.product-card__review-overlay .jdgm-prev-badge').forEach(badge => {
        const rating = Number(badge.dataset.averageRating);
        if (!Number.isFinite(rating)) return;
        const display = (Math.floor(rating * 10 + 0.000001) / 10).toFixed(1);
        if (badge.dataset.displayRating !== display) badge.dataset.displayRating = display;
        let mobileRating = badge.querySelector('.product-card__rating-number');
        if (!mobileRating) {
          mobileRating = document.createElement('strong');
          mobileRating.className = 'product-card__rating-number';
          badge.appendChild(mobileRating);
        }
        if (mobileRating.textContent !== display) mobileRating.textContent = display;
        const score = badge.querySelector('.jdgm-prev-badge__text b');
        const desktopDisplay = (Math.round((rating + Number.EPSILON) * 10) / 10).toFixed(1);
        if (score && score.textContent !== desktopDisplay) score.textContent = desktopDisplay;
      });
    };
    const observer = new MutationObserver(() => {
      if (!scheduled) {
        scheduled = true;
        requestAnimationFrame(formatRatings);
      }
    });
    observer.observe(document.body, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-average-rating']});
    formatRatings();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('.product-info__inline-review');
    if (!link) return;
    const target = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    for (let parent = target.parentElement; parent; parent = parent.parentElement) {
      if (parent.tagName === 'DETAILS') parent.open = true;
    }
    target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
  }, true);
  let queued = false;
  const formatProductRatings = () => {
    queued = false;
    document.querySelectorAll('.product-info__inline-review .jdgm-prev-badge').forEach(badge => {
      const rating = Number(badge.dataset.averageRating);
      const score = badge.querySelector('.jdgm-prev-badge__text b');
      if (!Number.isFinite(rating) || !score) return;
      const value = (Math.round((rating + Number.EPSILON) * 10) / 10).toFixed(1);
      if (score.textContent !== value) score.textContent = value;
    });
  };
  new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(formatProductRatings); }
  }).observe(document.body, {subtree:true, childList:true, characterData:true});
  formatProductRatings();
})();

(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.product-info__features-scroll').forEach(viewport => {
    let previous = 0, pauseUntil = performance.now() + 1800, hovering = false, visible = true, dragging = false, startX = 0, startScroll = 0, userInteracted = false;
    const setup = () => {
      if (!userInteracted && !reducedMotion.matches) viewport.scrollLeft = 0;
    };
    setup();
    new ResizeObserver(setup).observe(viewport);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }).observe(viewport);
    const pause = () => { userInteracted = true; pauseUntil = performance.now() + 6000; };
    viewport.addEventListener('pointerdown', event => {
      pause();
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true; startX = event.clientX; startScroll = viewport.scrollLeft;
      viewport.setPointerCapture(event.pointerId);
      viewport.classList.add('is-dragging');
      event.preventDefault();
    });
    viewport.addEventListener('pointermove', event => {
      if (!dragging) return;
      viewport.scrollLeft = startScroll - (event.clientX - startX);
    });
    const endDrag = () => { dragging = false; viewport.classList.remove('is-dragging'); pause(); };
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('lostpointercapture', () => { dragging = false; viewport.classList.remove('is-dragging'); });
    viewport.addEventListener('touchmove', pause, {passive:true});
    viewport.addEventListener('wheel', pause, {passive:true});
    viewport.addEventListener('keydown', pause);
    viewport.addEventListener('mouseenter', () => { hovering = true; });
    viewport.addEventListener('mouseleave', () => { hovering = false; pauseUntil = performance.now() + 2000; });
    const rotate = () => {
      if (!viewport.isConnected) { clearInterval(timer); return; }
      if (!visible || dragging || hovering || viewport.matches(':focus-within') || performance.now() < pauseUntil || reducedMotion.matches) return;
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 1) return;
      const current = viewport.scrollLeft;
      const steps = Array.from(viewport.querySelectorAll('.product-info__features-track li')).map(item => item.offsetLeft - viewport.querySelector('.product-info__features-track').offsetLeft);
      const nextStep = steps.find(left => left > current + 2);
      viewport.scrollTo({left:current >= max - 1 ? 0 : Math.min(max, nextStep === undefined ? max : nextStep),behavior:'smooth'});
    };
    const timer = setInterval(rotate, 3000);

  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["swim-photo-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-swim-group],[data-swim-scroll]');
 if(!button)return;
 const picker=button.closest('.swim-photo-picker');
 const track=picker.querySelector('.swim-photo-picker__track');
 if(button.hasAttribute('data-swim-group')){
  picker.querySelectorAll('[data-swim-group]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
  picker.querySelectorAll('[data-swim-item]').forEach(item=>item.hidden=item.dataset.swimItem!==button.dataset.swimGroup);
  track.scrollLeft=0;
 }else track.scrollBy({left:Number(button.dataset.swimScroll)*194,behavior:'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["underwear-photo-selector"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
 const button=event.target.closest('[data-underwear-group],[data-underwear-scroll]');
 if(!button)return;
 const picker=button.closest('.underwear-photo-picker');
 const track=picker.querySelector('.underwear-photo-picker__track');
 if(button.hasAttribute('data-underwear-group')){
  picker.querySelectorAll('[data-underwear-group]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
  picker.querySelectorAll('[data-underwear-item]').forEach(item=>item.hidden=!item.dataset.underwearItem.split(' ').includes(button.dataset.underwearGroup));
  track.scrollLeft=0;
 }else track.scrollBy({left:Number(button.dataset.underwearScroll)*194,behavior:'smooth'});
});
  } catch(e) { console.error(e); }
})();

})();
